import { MenuItemCommandEvent } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { NavigationPath } from './navigation-path.model';

export class NavigationItem {
    private itemID: number;
    private permItemID: string;
    private itemName: string;
    private parentID: number;
    private unitCount: number;
    private indicatorCount: number;
    private path: NavigationPath;
    private items: Array<NavigationItem>;

    constructor(itemID: number, permItemID: string, itemName: string, parentID: number = 0, unitCount: number, indCount: number, path: NavigationPath, items: NavigationItem[]) {
        this.itemID = itemID;
        this.permItemID = permItemID;
        this.itemName = itemName;
        this.parentID = parentID;
        this.unitCount = unitCount;
        this.indicatorCount = indCount;
        this.path = path;
        this.items = items;
    }

    get ItemID(): number { return this.itemID; }
    set ItemID(value: number) { this.itemID = value; }

    get PermItemID(): string { return this.permItemID; }
    set PermItemID(value: string) { this.permItemID = value; }

    get ItemName(): string { return this.itemName; }
    set ItemName(value: string) { this.itemName = value; }

    get ParentID(): number { return this.parentID; }
    set ParentID(value: number) { this.parentID = value; }

    get UnitCount(): number { return this.unitCount; }
    set UnitCount(value: number) { this.unitCount = value; }

    get IndicatorCount(): number { return this.indicatorCount; }
    set IndicatorCount(value: number) { this.indicatorCount = value; }

    get Path(): NavigationPath { return this.path; }
    set Path(value: NavigationPath) { this.path = value; }

    get Items(): NavigationItem[] { return this.items; }
    set Items(value: NavigationItem[]) { this.items = value; }


    public static toMenuItemJSON(item: NavigationItem, callback: (menuEvent: MenuItemCommandEvent) => void): any {
        const json: any = {
            label: item.itemName,
            id: item.permItemID,
            icon: item.itemName,

            command: callback
        };

        if (item.items && item.items.length > 0) {
            json.items = [NavigationItem.getMenuItemsJson(item.items, callback)];
        }

        return json;
    }

    private static getMenuItemsJson(items: NavigationItem[], callback: (menuEvent: MenuItemCommandEvent) => void): any {
        const itemJsonArray = new Array<any>();
        items.forEach(item => {
            const itemJson = this.getMenuItemJson(item, callback);
            itemJsonArray.push(itemJson);
        });
        return itemJsonArray;
    }

    private static getMenuItemJson(item: NavigationItem, callback: (menuEvent: MenuItemCommandEvent) => void): any {
        const itemJson: any = {};
        itemJson.label = item.itemName;
        itemJson.id = item.permItemID;
        itemJson.command = callback;
        if (item.items && item.items.length > 0) {
            itemJson.items = [NavigationItem.getMenuItemsJson(item.items, callback)];
        }
        return itemJson;
    }

    public getNavigationItem(navid: number): NavigationItem {
        let foundItem: NavigationItem;
        if (this.ItemID === navid) {
            foundItem = this;
            return this;
        } else if ( (this.PermItemID === environment.HomePermId) && (navid === 0) ) {
            foundItem = this;
            return this;
        }

        // tslint:disable-next-line:prefer-for-of
        for (let index = 0; index < this.Items.length; index++) {
            const child = this.Items[index];
            foundItem = child.getNavigationItem(navid);
            if (foundItem) {
                break;
            }
        }
        return foundItem;
    }

    public getNavigationItemUsingPerm(permid: string) {
        let foundItem: NavigationItem;
        if (this.PermItemID === permid) {
            foundItem = this;
            return this;
        }

        // tslint:disable-next-line:prefer-for-of
        for (let index = 0; index < this.Items.length; index++) {
            const child = this.Items[index];
            foundItem = child.getNavigationItemUsingPerm(permid);
            if (foundItem) {
                break;
            }
        }
        return foundItem;
    }

    public getNavigationItemUsingItem(itemid: number) {
        let foundItem: NavigationItem;
        if (this.ItemID === itemid) {
            foundItem = this;
            return this;
        }

        // tslint:disable-next-line:prefer-for-of
        for (let index = 0; index < this.Items.length; index++) {
            const child = this.Items[index];
            foundItem = child.getNavigationItemUsingItem(itemid);
            if (foundItem) {
                break;
            }
        }
        return foundItem;
    }

    public toString(): string {
        const parts = this.subItemToString(this);
        const fullString = parts.join(';');
        return fullString;
    }

    private subItemToString(item: NavigationItem): Array<string> {
        const parts = new Array<string>();
        if (item.Path && item.Path.Query) {
            const queryString = item.Path.Query.toString();
            parts.push(queryString);
        }
        if (item.Items) {
            this.Items.forEach(subitem => {
                const subItemParts = this.subItemToString(subitem);
                const subItemString = subItemParts.join(';');
                parts.push(subItemString);
            });
        }
        return parts;
    }

}
